export default __webpack_public_path__ + "app/views/accounts/detail/intradays/tab.html";